"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilters = void 0;
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var sortedUniqBy_1 = __importDefault(require("lodash/sortedUniqBy"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var constants_1 = require("../../../api/constants");
var AssessmentsFilterCriteria_1 = require("../AssessmentFilters/AssessmentsFilterCriteria");
var api_1 = require("../../../api");
var useFilters = function (_a) {
    var filterHandler = _a.filterHandler, curriculums = _a.curriculums, languageFilterHandler = _a.languageFilterHandler, curriculumByGlobalNav = _a.curriculumByGlobalNav;
    var _b = (0, react_1.useState)({
        gradesOptions: [],
        modulesOptions: [],
        topicsOptions: [],
        assessmentTypeOptions: [],
    }), filters = _b[0], setFilters = _b[1];
    var _c = (0, react_1.useState)(false), filtering = _c[0], setFiltering = _c[1];
    var _d = (0, react_1.useState)(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria()), filterCriteria = _d[0], setFilterCriteria = _d[1];
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var assessmentTemplateService = (0, react_1.useContext)(api_1.ServiceContext).assessmentTemplateService;
    var uniqueSortedOptions = function (options) {
        return (0, sortedUniqBy_1.default)((0, sortBy_1.default)(options, 'id'), 'id');
    };
    var uniqueOptions = function (options) { return (0, uniqBy_1.default)(options, 'id'); };
    var getFilterDropDownOptions = function (elements, criteria) {
        return elements.map(function (element) { return ({
            id: element.id,
            title: element.name,
            selected: criteria.includes(element.id),
        }); });
    };
    var getSelectedOptions = function (elements, criteria) { return elements.filter(function (_a) {
        var id = _a.id;
        return criteria.includes(id);
    }); };
    var getAssignmentTypes = (0, react_1.useCallback)(function (criteria) { return __awaiter(void 0, void 0, void 0, function () {
        var assignmentTypes, assignmentOptions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!curriculumByGlobalNav) return [3 /*break*/, 2];
                    return [4 /*yield*/, assessmentTemplateService.findAssignmentTypesByCurriculum(curriculumByGlobalNav)];
                case 1:
                    assignmentTypes = _a.sent();
                    assignmentOptions = assignmentTypes
                        .map(function (type) {
                        return Object.values(constants_1.AssignmentType).includes(type)
                            ? type
                            : null;
                    });
                    return [2 /*return*/, assignmentOptions.map(function (type) { return ({
                            id: type,
                            title: t("assignmentTypes.".concat(type)),
                            selected: criteria.assignmentType.includes(type),
                        }); })];
                case 2: return [2 /*return*/, []];
            }
        });
    }); }, [curriculumByGlobalNav, assessmentTemplateService, t]);
    var setFiltersOptions = (0, react_1.useCallback)(function (criteria) { return __awaiter(void 0, void 0, void 0, function () {
        var gradeOptions, modulesOptions, topicsOptions, selectedGrades, selectedModules, selectedCurriculum, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    gradeOptions = [];
                    modulesOptions = [];
                    topicsOptions = [];
                    selectedGrades = [];
                    selectedModules = [];
                    // Generate dropdown options for curriculums and get selected curriculums
                    // If there are selected curriculums, generate grade options for each curriculum
                    if (curriculumByGlobalNav) {
                        selectedCurriculum = curriculums.find(function (item) { return item.id === curriculumByGlobalNav; });
                        if (!selectedCurriculum)
                            return [2 /*return*/];
                        // Add grade options for this curriculum
                        gradeOptions = gradeOptions.concat(getFilterDropDownOptions(selectedCurriculum.grades, criteria.grades));
                        // Track which grades are selected
                        selectedGrades = selectedGrades.concat(getSelectedOptions(selectedCurriculum.grades, criteria.grades));
                    }
                    // If there are selected grades, generate module options for each grade
                    if (!(0, isEmpty_1.default)(selectedGrades)) {
                        selectedGrades.forEach(function (grade) {
                            // Add module options for this grade
                            modulesOptions = modulesOptions.concat(getFilterDropDownOptions(grade.modules, criteria.modules));
                            // Track which modules are selected
                            selectedModules = selectedModules.concat(getSelectedOptions(grade.modules, criteria.modules));
                        });
                    }
                    // If there are selected modules, generate topic options for each module
                    if (!(0, isEmpty_1.default)(selectedModules)) {
                        selectedModules.forEach(function (module) {
                            // Add topic options for this module
                            topicsOptions = topicsOptions.concat(getFilterDropDownOptions(module.topics, criteria.topics));
                        });
                    }
                    // Update the filters state with all generated options
                    // Note: uniqueSortedOptions ensures options are unique and sorted
                    // uniqueOptions only ensures uniqueness (used for grades which may not need sorting)
                    _a = setFilters;
                    _b = {
                        gradesOptions: uniqueOptions(gradeOptions),
                        modulesOptions: uniqueSortedOptions(modulesOptions),
                        topicsOptions: uniqueSortedOptions(topicsOptions)
                    };
                    return [4 /*yield*/, getAssignmentTypes(criteria)];
                case 1:
                    // Update the filters state with all generated options
                    // Note: uniqueSortedOptions ensures options are unique and sorted
                    // uniqueOptions only ensures uniqueness (used for grades which may not need sorting)
                    _a.apply(void 0, [(
                        // Fetch and add assessment type options asynchronously
                        _b.assessmentTypeOptions = _c.sent(),
                            _b)]);
                    return [2 /*return*/];
            }
        });
    }); }, [curriculums, setFilters, getAssignmentTypes, curriculumByGlobalNav]);
    var filter = function (criteria) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFiltering(true);
                    setFilterCriteria(criteria);
                    return [4 /*yield*/, setFiltersOptions(criteria)];
                case 1:
                    _a.sent();
                    filterHandler(criteria);
                    setFiltering(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var filterByGrade = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var grades;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    grades = selectedOptions.map(function (grade) { return grade.id; });
                    return [4 /*yield*/, filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                            curriculums: [curriculumByGlobalNav],
                            grades: grades,
                            assessmentType: filterCriteria.assessmentType,
                            assignmentType: filterCriteria.assignmentType,
                            language: filterCriteria.language,
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var filterByModule = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var modules;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    modules = selectedOptions.map(function (module) { return module.id; });
                    return [4 /*yield*/, filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                            curriculums: [curriculumByGlobalNav],
                            grades: filterCriteria.grades,
                            modules: modules,
                            assessmentType: filterCriteria.assessmentType,
                            assignmentType: filterCriteria.assignmentType,
                            language: filterCriteria.language,
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var filterByAssignmentType = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var assignmentTypeSelected;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    assignmentTypeSelected = selectedOptions.map(function (assessmentType) { return assessmentType.id; });
                    return [4 /*yield*/, filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                            curriculums: [curriculumByGlobalNav],
                            grades: filterCriteria.grades,
                            modules: filterCriteria.modules,
                            topics: filterCriteria.topics,
                            language: filterCriteria.language,
                            assignmentType: assignmentTypeSelected,
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var filterByTopic = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var topics;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    topics = selectedOptions.map(function (topic) { return topic.id; });
                    return [4 /*yield*/, filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria({
                            curriculums: [curriculumByGlobalNav],
                            grades: filterCriteria.grades,
                            modules: filterCriteria.modules,
                            topics: topics,
                            assessmentType: filterCriteria.assessmentType,
                            language: filterCriteria.language,
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var filterByLanguage = function (selectedOptions) {
        var selectedOption = selectedOptions[0];
        languageFilterHandler(selectedOption.id);
        var criteria = new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria(__assign(__assign({}, filterCriteria), { language: selectedOption.id }));
        setFilterCriteria(criteria);
    };
    var resetFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, filter(new AssessmentsFilterCriteria_1.AssessmentsFilterCriteria())];
                case 1:
                    _a.sent();
                    languageFilterHandler('');
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        filtering: filtering,
        filterBy: {
            Grade: filterByGrade,
            Module: filterByModule,
            AssignmentType: filterByAssignmentType,
            Topic: filterByTopic,
            Language: filterByLanguage,
        },
        resetFilters: resetFilters,
        filterCriteria: filterCriteria,
        filters: filters,
        setFiltersOptions: setFiltersOptions,
    };
};
exports.useFilters = useFilters;
